import type { ReactNode } from 'react'
import { cn } from '@/lib/cn'

export function Card({ className, children }: { className?: string; children: ReactNode }) {
  return (
    <section className={cn('rounded-card border border-rule bg-surface shadow-card', className)}>
      {children}
    </section>
  )
}

export function CardHeader({
  title,
  description,
  actions,
  className,
}: {
  title: string
  description?: ReactNode
  actions?: ReactNode
  className?: string
}) {
  return (
    <header
      className={cn('flex items-start gap-3 border-b border-rule px-4 py-3', className)}
    >
      <div className="min-w-0 flex-1">
        <h2 className="text-[15px] leading-6">{title}</h2>
        {description && (
          <p className="mt-0.5 text-[13px] leading-5 text-ink-muted">{description}</p>
        )}
      </div>
      {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
    </header>
  )
}

export function CardBody({ className, children }: { className?: string; children: ReactNode }) {
  return <div className={cn('p-4', className)}>{children}</div>
}

export function CardFooter({ className, children }: { className?: string; children: ReactNode }) {
  return (
    <footer className={cn('flex items-center gap-2 border-t border-rule px-4 py-3', className)}>
      {children}
    </footer>
  )
}
